import clsx from '@vangst/lib/clsx'
import {
  QuizAttemptStatusEnum,
  QuizFragment,
  TrainingFragment,
} from '@vangst/services/oogst/types'
import useViewer from '@vangst/services/oogst/viewer/useViewer'
import Routes from '@vangst/services/routes'
import ClickyLiner from '../../../components/navigation/ClickyLiner'
import ClickyLink from '../../../components/navigation/ClickyLink'

type PropsType = {
  readonly currentQuizId: string
  readonly quizzes: QuizFragment[]
  readonly training: TrainingFragment
}

export default function CourseTabs(props: PropsType) {
  const { quizzes, currentQuizId, training } = props
  const match = quizzes.find((quiz) => quiz.slug === currentQuizId)
  const selectedIndex = quizzes.indexOf(match as QuizFragment)
  const { viewer } = useViewer()

  return (
    <div className="py-4">
      <div className="flex flex-wrap gap-y-2">
        <span className="mr-4 flex items-center text-md font-700 text-blue-dark sm:text-lg">
          Quiz:
        </span>

        {quizzes?.map((quiz, index, collection) => {
          const submittedAttemptsOfPreviousQuiz =
            index === 0 && collection.length === 1
              ? []
              : collection[index - 1]?.currentUserQuizAttempts?.filter(
                  (attempt) =>
                    attempt?.status === QuizAttemptStatusEnum.Submitted,
                )
          const hasSubmittedAnAttempt =
            submittedAttemptsOfPreviousQuiz != null &&
            submittedAttemptsOfPreviousQuiz.length > 0

          // The link to the next quiz Part should be disabled until a user has submitted an attempt
          // to the previous quiz part.
          const disabled =
            (collection.length > 1 && index > 0 && !hasSubmittedAnAttempt) ||
            !viewer?.permissions?.trainableUser

          const uri = disabled
            ? ''
            : Routes?.COMPANIES_COURSE?.replace(
                ':displayname',
                training.creatorClient.displayname,
              )
                ?.replace(':tid', training?.slug ?? '')
                ?.replace(':id', quiz.slug)

          return (
            <span
              key={`quiz-part-${index + 1}`}
              className="border-l border-l-blue-dark px-2 last-of-type:border-r last-of-type:border-r-blue-dark"
            >
              <ClickyLiner
                activate="contains"
                disabled={disabled}
                className={clsx(
                  'visited[&:not:active]:text-grey-mid visited[&:not:active]:font-400  visited[&:not:active]:border-b max-w-fit px-2 text-blue-dark disabled:font-400 disabled:text-grey-dark hocus:text-blue',
                )}
                href={uri}
              >
                <span>Part {index + 1}</span>
              </ClickyLiner>
            </span>
          )
        })}
      </div>
      <ClickyLink
        className="link-blue-dark mt-4 block underline sm:hidden"
        href="#aside"
      >
        Take the quiz below
      </ClickyLink>
      <div key={`tabpanel-${match?.id}`} className="mt-4 flex flex-col">
        <span className="text-lg font-600">
          Part {selectedIndex + 1} Overview:
        </span>
        <span className="text-sm">{match?.description}</span>
      </div>
    </div>
  )
}
